export const toArray = <T>(maybeArray: T | T[] = []) => ([] as T[]).concat(maybeArray);
